import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getMarketingSummary } from "../../services/apiClient.js";
import { useSystemSetting } from "../shared/useSystemSetting.js";

// RDR marketing counters (legacy HandleMarketingPhCalls + HandlePMMarketingPhCalls):
// subscribed assessors with NO phone update this week (red, per list owner) and
// calls made this week per user. Click-through = the Marketing Phone Calls page.
// Hidden entirely while the marketing System Setting is OFF (super-busy periods:
// "you have made 0 calls" is a distraction, not a prompt).
function MarketingCallsPanel({ embedded = false }) {
  const [s, setS] = useState(null);
  const marketingOn = useSystemSetting("marketing_calls_enabled");
  const navigate = useNavigate();

  useEffect(() => {
    getMarketingSummary().then(setS).catch(() => {});
  }, []);

  if (marketingOn === false || !s) return null;
  return (
    // embedded = inside the dashboard header's left column (no own panel box)
    <div className={embedded ? "" : "placeholder-panel"}>
      <div
        role="button"
        className="d-flex flex-wrap justify-content-between align-items-center column-gap-3 py-1 clickable"
        data-hint="Open the Marketing Phone Calls worklist"
        onClick={() => navigate("/marketing")}
      >
        <span className={`fw-semibold ${s.due_total > 0 ? "text-danger" : ""}`}>
          Market Phone Calls — {s.due_total === 0 ? "everyone phoned this week" : `${s.due_total} assessor${s.due_total === 1 ? "" : "s"} not phoned this week`}
        </span>
        <span className="small text-muted">
          {s.due_by_owner.map((o) => `${o.owner}: ${o.n}`).join(" · ")}
        </span>
      </div>
      <div className="d-flex flex-wrap justify-content-between align-items-center column-gap-3 py-1 border-top">
        <span className="fw-semibold">PCO Market Phone Calls Made (this week) — {s.made_total}</span>
        <span className="small text-muted">
          {s.made_by_user.map((m) => `${m.caller}: ${m.n}`).join(" · ") || "none yet"}
        </span>
      </div>
    </div>
  );
}

export default MarketingCallsPanel;
